import { Map } from "ola-maps-react";
import Marker from './map-components/marker'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { solarizedlight } from 'react-syntax-highlighter/dist/esm/styles/prism';

const App = () => {

  const string1 = `
  const App = () => {
    return (
    <div style={{ width: "45%", height: "500px", position: "relative" }}>
      <Map zoom={1}>
        <Marker position={{ lat: 53.40, lng: 13.0 }} name="London" />
        <Marker position={{ lat: 28.7041, lng: 77.1025 }} name="Delhi" />
      </Map>
    </div>);
  }`;

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center", justifyContent: "center" }}>
      <h1 style={{color:"rgb(101, 123, 131"}}>Ola Maps package</h1>
      <a href="https://www.linkedin.com/in/niranjanjgowda/" style={{color:"rgb(101, 123, 131"}}>reach out if you have queries</a>
      <div style={{display: "flex", flexDirection: "column", width: "100%", gap: "2%", alignItems: "center", justifyContent: "center", padding:"5px"}}>
        <div style={{ maxWidth: "800px", width:"100%", position: "relative"}}>
          <SyntaxHighlighter language="javascript" style={solarizedlight}>
            {"  npm install ola-maps-react"}
          </SyntaxHighlighter>
          <SyntaxHighlighter language="javascript" style={solarizedlight}>
            {string1}
          </SyntaxHighlighter>
        </div>
        <div style={{ width: "100%", maxWidth: "800px" , height: "300px", position: "relative", paddingTop: "18px" }}>
          <Map zoom={1}>
            <Marker position={{ lat: 53.40, lng: 13.0 }} name="London" />
            <Marker position={{ lat: 28.7041, lng: 77.1025 }} name="Delhi" />
          </Map>
        </div>
      </div>
    </div>
  );
}

export default App;